import React, { useMemo } from "react";
import Select from "react-select";
import { useTranslation } from 'react-i18next';
import useClientsStore from "../../stores/useClientsStore";

export const DropDownClients = ({ value, allowEmpty = true, ...props }) => {
  const { t } = useTranslation();
  const clients = useClientsStore((state) => state.clients);
  const isLoading = useClientsStore((state) => state.isLoading);
  const isLoaded = useClientsStore((state) => state.isLoaded);

  const options = useMemo(() => {
    return clients.map((item) => ({
      label: item.name,
      value: item.id,
      idClient: item.id,
    }));
  }, [clients]);

  const selectedOption = useMemo(() => {
    if (value !== undefined && value !== null) {
      return options.find((opt) => opt.idClient === value) || null;
    }
    return null;
  }, [options, value]);

  const handleChange = (selected) => {
    if (props.onChange) {
      if (selected) {
        props.onChange({ idClient: selected.idClient });
      } else {
        // Cleared selection
        props.onChange({ idClient: null });
      }
    }
  };

  const showLoading = isLoading || !isLoaded;

  return (
    <Select
      className={props.className}
      options={options}
      value={selectedOption}
      onChange={handleChange}
      isDisabled={props.disabled || showLoading}
      isLoading={showLoading}
      isClearable={allowEmpty}
      isSearchable
      placeholder={showLoading ? t('dropdowns.loadingClients') : t('dropdowns.selectClient')}
      noOptionsMessage={() => t('dropdowns.noClientsFound')}
      loadingMessage={() => t('dropdowns.loadingMessage')}
    />
  );
};
